// Auto-generated file
export default {
    'atomic-component-error': async () => await import('./atomic-component-error/atomic-component-error.js'),
    'atomic-icon': async () => await import('./atomic-icon/atomic-icon.js'),
};
